import { extend } from 'lodash';

export class Model {
    id: string | number;
    totalCount?: number;

    constructor(input?: any) {
        extend(this, input);
    }

    setTotalCount(count: number) {
        this.totalCount = count;
    }
}
